import _ from 'lodash'

import i18n from '@/i18n/i18n'
import SurveyService from '@/services/admin/SurveyService.js'

import { errorMessage } from '@/utilities/helpers.js'

import { SURVEY_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true

export const state = {
  questions: null,
  question: {},
  choices: null,
  choice: {},
  requirements: {},
  meta: null
}

export const mutations = {
  SET_QUESTIONS(state, questions) {
    state.questions = questions.data
  },
  SET_SORTED_QUESTIONS(state, questions) {
    questions.map((value, index) => {
      questions[index].sequence = index + 1
    })
    state.questions = questions
  },
  SET_QUESTION(state, question) {
    state.question = question
  },
  DELETE_QUESTION(state, questionId) {
    state.questions = state.questions.filter(question => question.id !== questionId)
  },
  ADD_REQUIREMENT(state, requirement) {
    state.requirements.push(requirement)
  },
  SET_REQUIREMENTS(state, requirements) {
    state.requirements = requirements
  },
  DELETE_REQUIREMENT(state, requirementId) {
    state.requirements = _.filter(state.requirements, function (req) {
      return req.id !== requirementId
    })
  },
  ADD_QUESTION(state, question) {
    state.questions.push(question)
  },
  SET_CHOICES(state, choices) {
    state.choices = choices.data
  },
  SET_CHOICE(state, choice) {
    state.choice = choice
    let index = _.findIndex(state.choices, item => {
      return item.id === choice.id
    })

    if (index !== -1) {
      state.choices[index] = choice
    }
  },
  ADD_CHOICE(state, choice) {
    state.choices.push(choice)
  }
}
export const getters = {
  getQuestionById: state => id => {
    return state.questions ? state.questions.find(question => question.id === id) : false
  },
  getRequirementsByQuestionId: state => id => {
    return state.questions ? state.questions.find(question => question.id === id) : false
  },
  getChoiceById: state => id => {
    return state.choices ? state.choices.find(choice => choice.id === id) : false
  }
}

export const actions = {
  getQuestions({ commit, dispatch, state }) {
    if (state.questions) return true

    return new Promise((resolve, reject) => {
      SurveyService.getQuestions()
        .then(response => {
          commit('SET_QUESTIONS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SURVEY_ERROR_MESSAGES.getQuestionsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getQuestionsByTarget({ commit, dispatch, state }, target) {
    if (state.questions) return true

    return new Promise((resolve, reject) => {
      SurveyService.getQuestionsByTarget(target)
        .then(response => {
          commit('SET_QUESTIONS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SURVEY_ERROR_MESSAGES.getQuestionsByTargetError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getQuestion({ commit, state, getters }, id) {
    if (id == state.question.id) return state.question

    let question = getters.getQuestionById(id)

    if (question) {
      commit('SET_QUESTION', question)
      return question
    } else {
      return new Promise(resolve => {
        SurveyService.getQuestion(id).then(response => {
          commit('SET_QUESTION', response.data)
          resolve(response)
        })
      })
    }
  },
  getQuestionsWithComparingOrder({ commit, dispatch, state }, questionsArg) {
    const areQuestionArraysSameOrder =
      state.questions.length === questionsArg.length &&
      state.questions.every((question, index) => question.id === questionsArg[index].id)

    if (areQuestionArraysSameOrder) return true

    return new Promise((resolve, reject) => {
      SurveyService.getQuestions()
        .then(response => {
          commit('SET_QUESTIONS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SURVEY_ERROR_MESSAGES.getQuestionsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createQuestion({ dispatch, commit, state }, question) {
    return new Promise((resolve, reject) => {
      SurveyService.createQuestion(question)
        .then(response => {
          if (state.questions) {
            commit('ADD_QUESTION', response.data)
          }

          const notification = {
            type: 'success',
            message: t('store.shared.created', {
              element: t('store.admin.survey.new_question')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.create_error', {
                element: t('store.admin.survey.new_question')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sortQuestion({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      SurveyService.sortQuestion(params)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.survey.question_order')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.update_error', {
              element: t('store.admin.survey.question_order')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  setQuestions({ commit }, questions) {
    commit('SET_SORTED_QUESTIONS', questions)
  },
  deleteQuestion({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      SurveyService.deleteQuestion(params.id)
        .then(response => {
          commit('DELETE_QUESTION', params.id)
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.survey.question')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.not_deleted', {
                element: t('store.admin.survey.question')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(true)
        })
    })
  },
  getChoices({ commit, dispatch, state }, questionId) {
    if (state.question.id == questionId && state.choices) return state.choices

    return new Promise((resolve, reject) => {
      SurveyService.getChoices(questionId)
        .then(response => {
          commit('SET_CHOICES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.survey.choices')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getChoice({ commit, dispatch, state, getters }, params) {
    if (params.id == state.choice.id) return true

    let choice = getters.getChoiceById(params.id)

    if (choice) {
      commit('SET_CHOICE', choice)
      return choice
    } else {
      return new Promise((resolve, reject) => {
        SurveyService.getChoice(params.questionId, params.id)
          .then(response => {
            commit('SET_CHOICE', response.data)
            resolve(response)
          })
          .catch(err => {
            const notification = {
              type: 'danger',
              message:
                t('store.shared.fetching_problem', {
                  element: t('store.admin.survey.choices')
                }) + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          })
      })
    }
  },
  editChoice({ dispatch, commit }, choice) {
    return new Promise((resolve, reject) => {
      SurveyService.editChoice(choice.question_id, choice.id, choice)
        .then(response => {
          commit('SET_CHOICE', choice)
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.survey.choice')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.survey.choice')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createChoice({ dispatch, state, commit }, params) {
    return new Promise((resolve, reject) => {
      SurveyService.createChoice(params.questionId, params.choice)
        .then(response => {
          if (state.choices) {
            commit('ADD_CHOICE', response.data)
          }

          const notification = {
            type: 'success',
            message: t('store.shared.created', {
              element: t('store.admin.survey.choice')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.create_error', {
                element: t('store.admin.survey.choice')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRequirements({ commit, dispatch, state }, questionId) {
    const questionRequirements = _.find(state.requirements, requirement => requirement.question_id === questionId)
    if (questionRequirements) return questionRequirements

    return new Promise((resolve, reject) => {
      SurveyService.getRequirements(questionId)
        .then(response => {
          commit('SET_REQUIREMENTS', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.survey.conditions')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createSubCategoryRequirement({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      SurveyService.createSubCategoryRequirement(params.questionId, params.subCategories)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.survey.sub_category_as_condition')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          _.each(response.data, function (item) {
            commit('ADD_REQUIREMENT', item)
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.create_error', {
                element: t('store.admin.survey.condition')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createChoiceRequirement({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      SurveyService.createChoiceRequirement(params.choiceId, {
        question_id: params.questionId
      })
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.survey.choice_as_condition')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('ADD_REQUIREMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.create_error', {
                element: t('store.admin.survey.requirement')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteRequirement({ dispatch, commit, state }, params) {
    return new Promise((resolve, reject) => {
      SurveyService.deleteRequirement(params.questionId, params.requirementId)
        .then(response => {
          commit('DELETE_REQUIREMENT', params.requirementId)

          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.survey.condition')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('store.admin.survey.condition')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
